"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const PeakDataClient_1 = require("./PeakDataClient");
const ApiResponse_1 = __importDefault(require("../models/ApiResponse"));
class PeakDataGeographyClient {
    constructor(client) {
        this.client = client;
        this.endpoint = "api/Geography/:action";
        this.getCountriesAction = "GetCountries";
        this.getCountryAction = "GetCountry";
        this.getCitiesAction = "GetCities";
        this.getTownsAction = "GetTowns";
        this.getDistrictsAction = "GetDistricts";
        this.getNeighborhoodsAction = "GetNeighborhoods";
    }
    getCountriesAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.client.getAsync({
                path: this.endpoint,
                namedQueries: { action: this.getCountriesAction }
            });
        });
    }
    getCountries() {
        return PeakDataClient_1.asyncScheduled(this.getCountriesAsync());
    }
    getCountryAsync(name) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.client.getAsync({
                path: this.endpoint,
                namedQueries: { action: this.getCountryAction },
                queryStrings: { Name: name }
            });
        });
    }
    getCountry(name) {
        return PeakDataClient_1.asyncScheduled(this.getCountryAsync(name));
    }
    getCitiesAsync(params) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!params || !(params.countryId || params.countryName))
                return new ApiResponse_1.default();
            return this.client.getAsync({
                path: this.endpoint,
                namedQueries: { action: this.getCitiesAction },
                queryStrings: params.countryId ? { CountryId: params.countryId } : { CountryName: params.countryName }
            });
        });
    }
    getCities(params) {
        return PeakDataClient_1.asyncScheduled(this.getCitiesAsync(params));
    }
    getTownsAsync(params) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!params || !(params.cityId || params.cityName))
                return new ApiResponse_1.default();
            return this.client.getAsync({
                path: this.endpoint,
                namedQueries: { action: this.getTownsAction },
                queryStrings: params.cityId ? { CityId: params.cityId } : { CountryName: params.cityName }
            });
        });
    }
    getTowns(params) {
        return PeakDataClient_1.asyncScheduled(this.getTownsAsync(params));
    }
    getDistrictsAsync(params) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!params || !(params.townId || params.townName))
                return new ApiResponse_1.default();
            return this.client.getAsync({
                path: this.endpoint,
                namedQueries: { action: this.getDistrictsAction },
                queryStrings: params.townId ? { TownId: params.townId } : { TownName: params.townName }
            });
        });
    }
    getDistricts(params) {
        return PeakDataClient_1.asyncScheduled(this.getDistrictsAsync(params));
    }
    getNeighborhoodsAsync(districtId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.client.getAsync({
                path: this.endpoint,
                namedQueries: { action: this.getNeighborhoodsAction },
                queryStrings: { DistrictId: districtId }
            });
        });
    }
    getNeighborhoods(districtId) {
        return PeakDataClient_1.asyncScheduled(this.getNeighborhoodsAsync(districtId));
    }
}
exports.default = PeakDataGeographyClient;
